/* eslint-disable no-unused-vars */
import React from 'react';
/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import cvPdf from '../assets/Lukas_Sivak_CV_30.November.25.pdf'; // updated CV

const HeroSection = styled.section`
  padding: 7rem 1.5rem 5rem;
  background: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.text};
  transition: background 0.4s ease, color 0.4s ease;
`;

const HeroTitle = styled.h1`
  font-size: clamp(2.8rem, 4vw, 3.6rem);
  margin-bottom: 0.75rem;
  letter-spacing: -0.03em;
`;

const HeroSubtitle = styled.h2`
  font-size: 1.1rem;
  margin-bottom: 1.8rem;
  color: ${({ theme }) => theme.textSecondary || theme.text};
  letter-spacing: 0.12em;
  text-transform: uppercase;
`;

const HeroTagline = styled.p`
  margin: 1.25rem 0 0.5rem;
  max-width: 640px;
  font-size: 1.05rem;
  line-height: 1.7;
`;

const HeroButtons = styled.div`
  margin-top: 2.2rem;
  display: flex;
  gap: 0.9rem;
  flex-wrap: wrap;
  align-items: center;
`;

const PrimaryButton = styled.a`
  background: ${({ theme }) => theme.accent || '#c61823'};
  color: ${({ theme }) => theme.background};
  padding: 0.85rem 1.9rem;
  border-radius: 0px;
  text-decoration: none;
  font-weight: 700;
  letter-spacing: 0.02em;
  font-size: 15px;
  min-width: 150px;
  transition: transform 0.2s ease, opacity 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    opacity: 0.9;
  }
`;

const GhostButton = styled.a`
  border: 1px solid ${({ theme }) => theme.line || 'rgba(12,12,12,0.12)'};
  color: ${({ theme }) => theme.text};
  padding: 0.75rem 1.75rem;
  border-radius: 0px;
  text-decoration: none;
  font-weight: 600;
  letter-spacing: 0.02em;
  font-size: 15px;
  min-width: 150px;
  background: transparent;
  transition: transform 0.2s ease, border-color 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    border-color: ${({ theme }) => theme.accent || '#c41f26'};
  }
`;

function Hero() {
  return (
    <HeroSection id="hero">
      <div className="hero-content" style={{ maxWidth: '1180px', margin: '0 auto', display: 'grid', gap: '1rem', alignItems: 'start' }}>
        <HeroSubtitle>Junior Developer — Front-End Focus | Learning Backend</HeroSubtitle>
        <HeroTitle>Digital experiences with clarity and intention.</HeroTitle>
        <HeroTagline>
          I build clean, accessible web interfaces with React — focused on structure, speed, and calm design.
          <br />
          No clutter. No noise. Just clear, usable UI.
        </HeroTagline>
        <HeroButtons>
          <PrimaryButton href="#projects">View Work</PrimaryButton>
          <GhostButton href={cvPdf} download>
            Download CV
          </GhostButton>
          <GhostButton href="#contact">Contact</GhostButton>
        </HeroButtons>
      </div>
    </HeroSection>
  );
}

export default Hero;
